import http from '../utils/fetch'


export default {
  getRegion (cb) {
    if (process.env.NODE_ENV === 'development') {
      cb('SHSH')
    } else {
      http.get({url: 'locate.do'}).then(
        (response) => {
          cb(response)
        },
        () => {
        }
      )
    }
  },
  isRegistered (phone, cb) {
    http.get({url: `check-phone.do?phone=${phone}`}).then(
      (response) => {
        cb(response)
      },
      () => {
      }
    )
  },
  requestCaptcha (phone, cb, errorCb) {
    http.post({url: `captcha.do?phone=${phone}`}).then(
      (response) => {
        if (response.error === 0) {
          cb(response)
        } else {
          errorCb(response)
        }
      },
      (response) => {
        errorCb(response)
      })
  },
  login (phone, password, cb, errorCb) {
    http.get({url: `auth?mode=WEB_PC&phone=${phone}&password=${password}`}).then(
      (response) => {
        cb(response.token)
      },
      (response) => {
        errorCb(response)
      })
  },
  smsLogin (phone, captcha, cb, errorCb) {
    http.get({url: `auth/sms?phone=${phone}&captcha=${captcha}`}).then(
      (response) => {
        cb(response.token)
      },
      (response) => {
        errorCb(response)
      })
  },
  resetPassword (phone, password, captcha, cb, errorCb) {
    http.patch({
      url: 'auth',
      data: {
        phone: phone,
        password: password,
        captcha: captcha
      }
    }).then(
      (response) => {
        cb(response.token)
      },
      (response) => {
        // debugger
        errorCb(response)
      }
    )
  },
  register (phone, password, captcha, cb, errorCb) {
    http.post({
      url: 'auth',
      data: {
        phone: phone,
        password: password,
        captcha: captcha
      }
    }).then(
      (response) => {
        cb(response.token)
      },
      (response) => {
        errorCb(response)
      }
    )
  },
  getWxBaseInfo (code, cb) {
    http.get({url: `proxy/wx/access-token?code=${code}`})
      .then(
        (response) => {
          cb(response)
        },
        () => {
        }
      )
  },
  getWxBaseInfoFromOpenPlatform (code, cb) {
    http.get({url: `proxy/wx/access-token/open?code=${code}`})
      .then(
        (response) => {
          cb(response)
        },
        () => {
        }
      )
  },
  getLoginHistory (cb, errorCb) {
    // http.headers.common['Authorization'] = token
    http.get({url: 'login-history'})
      .then(
        (response) => {
          cb(response.content)
        },
        (response) => {
          errorCb(response)
        }
      )
  },
  getUser (cb, errorCb, ignoreErr = false) {
    http.get({url: 'users', ignoreErr}).then(
      (response) => {
        cb(response)
      },
      (response) => {
        errorCb(response)
      }
    )
  },
  getCompany (cb, errorCb) {
    http.get({url: 'company'}).then(
      (response) => {
        cb(response)
      },
      (response) => {
        errorCb(response)
      }
    )
  },
  updateCompany (company, cb, errorCb) {
    http.put({
      url: 'company',
      data: company
    }).then(
      (response) => {
        cb(response)
      },
      (response) => {
        errorCb(response)
      }
    )
  },
  fetchEmpName(empNumber) {
    return http.get({
      url: '/employee/' + empNumber
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js